module.exports = __webpack_public_path__ + "img/138952fundacion-universitaria-las-palmas.37536dfa.jpg";